import { AccessLevel, Section } from 'app/frontend/types/custom'
import { createContext, useContext } from 'react'

export interface AuthContextType {
  accessLevel: AccessLevel
  section: Section
  requirement: AccessLevel
}

const AuthContext = createContext<AuthContextType>({
  accessLevel: 'none',
  section: 'base',
  requirement: 'member',
} as AuthContextType)

export const useAuth = () => {
  const context = useContext(AuthContext)

  if (context === undefined) {
    throw new Error('useAuth must be used within a AuthProvider')
  }

  return context
}

export default AuthContext
